import { getStore, SearchTab } from 'owa-mail-search';

export default function getShouldShowTabbedSearch(): boolean {
    const activeSearchTab = getStore().activeSearchTab;
    return activeSearchTab && activeSearchTab !== SearchTab.Mail;
}
